import moment from 'moment';
import { useSettingsStore } from '@/stores';

export function useFormat() {
    const settings = useSettingsStore();

    const currency = (value) => {
        const amount = Number(value || 0);
        const code = settings.currency || 'USD';
        try {
            return new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: code,
                minimumFractionDigits: 2,
            }).format(amount);
        } catch (e) {
            // Fallback if the currency code is not a valid ISO code.
            return `${amount.toFixed(2)} ${code}`;
        }
    };

    const date = (value) => (value ? moment(value).format('YYYY-MM-DD') : '—');

    const datetime = (value) => (value ? moment(value).format('YYYY-MM-DD HH:mm') : '—');

    return { currency, date, datetime };
}

export default useFormat;
